import { createSelector } from 'reselect';
import moment from 'moment';

class OfferSelectors {
    static getOffers = (state) => state.offer.offers;

    static getSelectedOfferIndex = (state) => state.offer.selectedOfferIndex;

    static getOffersRetrieved = (state) => state.offer.offersRetrieved;

    static getSelectedProductIndex = (state) =>
        state.offer.selectedProductIndex;

    static showOfferSelect = createSelector(
        OfferSelectors.getOffers,
        OfferSelectors.getSelectedOfferIndex,
        (offers, index) => index > -1 && offers.length > 1
    );

    static getSelectedOffer = createSelector(
        OfferSelectors.getOffers,
        OfferSelectors.getSelectedOfferIndex,
        (offers, index) => (index >= 0 ? offers[index] : null)
    );

    static getSelectedCurrency = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => (offer ? offer.currency : 'USD')
    );

    static getSelectedOfferId = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => (offer ? offer.id : '')
    );

    static getSelectedTransactions = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => (offer ? offer.transactions : [])
    );

    static getSelectedBalance = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => (offer ? offer.balance : 0)
    );

    static getLastTransaction = createSelector(
        OfferSelectors.getSelectedTransactions,
        (transactions) =>
            transactions.reduce(
                (result, t) =>
                    moment(t.lastModified) > moment(result.lastModified)
                        ? t
                        : result,
                transactions[0]
            )
    );

    static getSortedTransactions = createSelector(
        OfferSelectors.getSelectedTransactions,
        (transactions) =>
            transactions.slice().sort((a, b) => {
                if (a.lastModified < b.lastModified) {
                    return 1;
                }
                if (a.lastModified > b.lastModified) {
                    return -1;
                }
                return 0;
            })
    );

    static getOfferIsUsable = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) =>
            Boolean(
                offer &&
                offer.active &&
                offer.account &&
                // offer.balance > 0 &&
                offer.pricing.length > 0 &&
                offer.sites.length > 0
            )
    );

    static getServersGroupedBySite = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => {
            const configured = {};
            const siteStash = {};

            if (!offer) {
                return [];
            }

            offer.servers.forEach((s) => (configured[s.id] = s));

            offer.sites.forEach((site) => {
                site.servers.forEach((server) => {
                    if (configured[server.id]) {
                        if (!siteStash[site.id]) {
                            siteStash[site.id] = Object.assign({}, site);
                            siteStash[site.id].servers = [];
                        }
                        siteStash[site.id].servers.push(server);
                    }
                });
            });

            return Object.values(siteStash);
        }
    );

    static getIsPricingContinuous = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => {
            if (!offer || offer.pricing.length === 0) {
                return false;
            }

            const monthly = offer.pricing[0].monthly;
            const amounts = monthly.map(m => m.amount);
            const min = Math.min(...amounts);
            const max = Math.max(...amounts);
            const amountSet = new Set(amounts);

            for (let i = min; i <= max; i++) {
                if (!amountSet.has(i)) {
                    return false;
                }
            }

            return true;
        }
    );

    static getHasOnlyWeeklyPricing = createSelector(
        OfferSelectors.getSelectedOffer,
        (offer) => {
            if (offer.weeklyPricingEnabled && offer.pricing[0]) {
                return (
                    offer.pricing[0].weekly.length > 0 &&
                    offer.pricing[0].monthly.length === 0
                );
            }
            return false;
        }
    );
}

export default OfferSelectors;



// WEBPACK FOOTER //
// ./app/selectors/offer.js